<template>
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
    </ul>

    <!-- slot main -->

    <div id="dashboard-canvas" class="col-xs-12 main with-leads-table with-leads-table-active" slot="main">
      <!-- components -->
      <div class="row ls-charts">
          <h1>Requests <span v-if="stats.customer">- {{ stats.customer }}</span></h1>
          <div class="pivots-wrapper" v-if="stats.available_campaigns">
              <span class="pivot label">
                  Campaign:
                        <select v-model="campaign">
                            <option :value="null"> - none - </option>
                            <option v-for="c in stats.available_campaigns" :value="c.id">{{ c.name  }}</option>
                        </select>
              </span>
          </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>Total</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ stats.total }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>OK</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ stats.ok }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>Error</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ stats.error }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>Test</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ stats.test }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>Conversions</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ stats.sales }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-2 col-md-4">
              <div class="box">
                <div class="panel stats">
                  <div class="panel-header">
                    <h3>Conv. Rate</h3>
                  </div>
                  <div class="panel-body">
                    <div class="metrics-banner-text text-center">{{ convRate | percentage }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">

            <div v-if="!campaign" class="col-xs-12 col-md-6">
                <div class="box">
                    <div class="panel">
                        <div class="panel-header">
                            <h3>Stats by Campaign</h3>
                        </div>
                        <div class="panel-body">
                            <div class="col-xs-12 chart-wrapper">
                                <ls-chart target-css-classes="chart"
                                          :target-id="'by_campaign'"
                                          v-bind:bc-data="stats.chart_by_campaign.series"
                                          v-bind:bc-layout="stats.chart_by_campaign.layout">
                                </ls-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!campaign" class="col-xs-12 col-md-6">
                <div class="box">
                    <div class="panel">
                        <div class="panel-header">
                            <h3>Count by Campaign</h3>
                        </div>
                        <div class="panel-body">
                            <ls-stats-table :table-data="stats.count_by_campaign" :table-layout="by_campaign_layout"></ls-stats-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xs-12">
          <div class="box">
            <div class="panel">
              <requests-table v-bind:campaign="campaign" v-bind:customer="customer" v-bind:datesRange="datesRange" @loaded="refreshStats"></requests-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="modals">

    </div>
  </base-layout>
</template>

<script>
 /**
  * https://github.com/jbaysolutions/vue-grid-layout
  */
 import Vue from 'vue';

 import {BaseLayout} from 'components/layouts/';
 import DateRangePicker from 'components/elements/DateRangePicker';
 import RequestsTable from 'components/elements/RequestsTable';
 import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
 import LsStatsTable from 'components/elements/LsStatsTable';

 // Load the full build.
 var _ = require('lodash');

 export default {
   components: {
     BaseLayout,
     LsChart,
     DateRangePicker,
     RequestsTable,
     LsStatsTable
   },
   data () {
     return {
         /* These are part of colums */
         campaign: null,
       by_campaign_layout: {
         header: [
           {key: 'customer', label: 'Customer'},
           {key: 'name', label: 'Campaign'},
           {key: 'ok', label: 'OK'},
           {key: 'error', label: 'ERROR'},
           {key: 'total', label: 'TOTAL'}
         ]
       },
       stats: {
           customer: null,
           campaign: null,
           available_campaigns: [],
         total: '-',
         ok: '-',
         error: '-',
         test: '-',
         sales: '-',
         count_by_campaign: [],
         chart_by_campaign: {
           'series': [],
           'layout': {}
         }
       },
       datesRange: {
         from: moment().subtract(29, "days").format("YYYY-MM-DD"),
         to: null,
         date_field: null
       },
       pagination: {
	 current_page: 1, // required
       }
     };
   },

   computed: {
     convRate () {
       if (this.stats.sales != '-' && this.stats.ok != '-'  && this.stats.ok > 0) {
         return this.stats.sales/this.stats.ok;
       }
       return '-';
     },
     customer () {
       if (this.$route.params.id) {
         return this.$route.params.id;
       }
       return null;
     }
   },
   watch: {
       '$route.params.id': {
           handler: function() {
               this.campaign = null;
           },
           deep: true,
           immediate: true
       }
   },

   created () {
       var u = this.$store.state.user;
       BUS.$on('refreshDashboard', this.reload);

   },
     methods: {
         reload() {
             let current = _.cloneDeep(this.datesRange);
             this.datesRange = null;
             this.datesRange = current;
         },
     refreshStats(stats) {
         this.stats = stats
     },
     updatedDates: _.debounce(function (datesRange) {
       this.datesRange = datesRange;
//       Vue.set(this, 'datesRange', datesRange);
     }),
   }
 }
</script>

<style lang="scss" scoped>
 .dashboard-header {
   color: #ddd;
   border-bottom: 1px solid #ddd;
   margin-bottom: 4px;
   padding: 0px;
 }
 .dashboard-header .btn-group {
   display: inline-block;
   margin-top: 3px;
 }
 .dashboard-header .col-xs-10,
 .dashboard-header .col-xs-2 {
   padding-left: 3px;
   padding-right: 3px;
 }
 .dashboard-header h3 {
   color: #ddd;
   font-size: 14pt;
 }
 .dashboard-header .btn-default {
   color: #ddd!important;
   border: 0px;
   border-radius: 0px;
   background: transparent;
 }
 .dashboard-header .btn-default:hover,
 .dashboard-header .btn-default:focus,
 .dashboard-header .btn-default:active {
   border: 0px;
   background: #aeaeae;
   shadow-box: 0;
   color: #555!important;
 }

 .empty-msg {
   margin: 30px auto;
 }


 /* Leads Queue styles */
 h1 .btn {
   background-color: transparent;
   margin-top: -8px;
 }

 h1 input {
   background: #fff;
   border: 0px!important;
   padding: 0px;
   padding-top: 4px;
   margin-top: -4px;
 }

 .leads-queue {
   padding: 0px!important;
   border: 1px solid #999;
   border-bottom: 0px;
   margin: 0px!important;
   float: none;
 }

 .leads-queue .chart-wrapper {
   padding: 0px!important;
   height: 100%!important;
 }

 .endeless-table-container {
   padding: 10px;
 }

 .leads-queue-wrapper {
   padding: 0px;
   position: absolute;
   height: 100%;
 }

 .leads-queue.full-height {
   position: absolute;
   height: 100%;
   width: 100%;
 }

 #dashboard-canvas {
   display: flex;
   flex-direction: column;
 }

 .ls-charts {
   flex: 100vh;
   flex-grow: 1;
   width: 100%;
   overflow: hidden;
   position: relative;
   margin: 0px!important;

   .chart-wrapper {
     height: 40vh;
     margin: 0;
   }
 }

 .ls-leads-table {
   display: flex;
   padding: 0px;
   position: relative;
   margin: 0px!important;
 }

 .with-leads-table .ls-charts {
   height: calc(100vh - 112px);
 }

 .with-leads-table.with-leads-table-active .ls-charts {
   height: 100%;
   flex-grow: 1;
   flex-basis: 35%;
   padding-bottom: 20px;
 }

 .with-leads-table.with-leads-table-active .ls-leads-table {
   height: 100%;
   flex-grow: 1;
   flex-basis: 65%;
 }

 .ls-charts-wrapper {
   position: absolute;
   height: calc(100% - 60px);
   overflow-y: auto;
   padding-bottom: 200px;
 }

 .ls-charts h1 {
   margin-left: 10px;
   margin-right: 10px;
 }

 .ls-charts > h4 {
   margin-top: -20px;
   margin-left: 30px;
   margin-right: 30px;
   padding: 5px 10px;
   background-color: #f5f5f5;
   border: #e3e3e3;
   border-radius: 0px 0px 4px 4px;
 }

 #dashboard-canvas h1 form {
   display: inline-block;
   width: 100%;
   height: 20px;
 }

 #dashboard-canvas h1 input[type="text"] {
   background-color: #efefef;
   display: inline-block;
   width: 90%;
 }

 .vue-grid-placeholder {
   background-color: #333!important;
   border-radius: 4px 4px 4px 4px;
 }

 .metrics-banner-text {
   font-size: 1.8em;
   font-weight: 600;
   color: #ff7a7c;
 }

 .ls-charts > .row {
   margin: 0px;
 }

 .box {

   padding: 10px;
 }

</style>



// WEBPACK FOOTER //
// Requests.vue?63548167